import script from "./TableActionsColumn.vue?vue&type=script&lang=js"
export * from "./TableActionsColumn.vue?vue&type=script&lang=js"

export default script